import React from 'react';
import { useLocation } from 'react-router-dom';
import { Info } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

// Maps a route to its feature-notes key (managed in Admin → Settings → Notes).
const routeToKey = (pathname) => {
  if (pathname.startsWith('/pnr-status')) return 'pnr_status';
  if (pathname.startsWith('/live-train-status')) return 'live_status';
  if (pathname.startsWith('/trains')) return 'schedule';
  if (pathname.startsWith('/food-on-train')) return 'food_on_train';
  if (pathname.startsWith('/cabs')) return 'cabs';
  if (pathname.startsWith('/stories')) return 'stories';
  return null;
};

/**
 * Feature-specific note / Terms & Conditions block shown below the main content.
 * Renders nothing when no note is configured for the current feature.
 * Pass `featureKey` to force a key (e.g. embedded cab view); otherwise it is
 * derived from the current route.
 */
const FeatureNote = ({ featureKey }) => {
  const settings = useSettings();
  const location = useLocation();
  const key = featureKey || routeToKey(location.pathname);
  if (!key) return null;

  const note = ((settings?.feature_notes || {})[key] || '').trim();
  if (!note) return null;

  return (
    <div className="max-w-5xl mx-auto px-3 md:px-4 mt-6 mb-2" data-testid={`feature-note-${key}`}>
      <div className="rounded-2xl border border-tp-violet/15 bg-white/80 backdrop-blur-sm shadow-sm overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-2.5 bg-tp-violet-soft/60 border-b border-tp-violet/10">
          <Info size={15} className="text-tp-violet-deep shrink-0" />
          <span className="text-xs font-bold uppercase tracking-wide text-tp-violet-deep">Please Note</span>
        </div>
        <p className="px-4 py-3 text-[13px] leading-relaxed text-tp-ink-soft whitespace-pre-line">
          {note}
        </p>
      </div>
    </div>
  );
};

export default FeatureNote;
